import React from 'react';
import { Box, Typography } from '@mui/material';

import { CloseButton, Dialog, DialogActions, DialogContent, DialogTitle, Loading, SubmitButton } from 'components';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices';
import { useDeleteServiceInterruptionMutation } from 'store/apis';

interface ServiceInterruptionDeleteDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  submitButtonLabel?: string;
  serviceInterruptionId: number;
  setServiceInterruptionId: (serviceInterruptionId?: number) => void;
}

export const ServiceInterruptionDeleteDialog = ({
  visible = false,
  setVisible = () => {},
  title = 'Delete Service Interruption',
  submitButtonLabel = 'Delete',
  serviceInterruptionId: id,
  setServiceInterruptionId,
}: ServiceInterruptionDeleteDialogProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [deleteServiceInterruption, { isLoading: loading_submit }] = useDeleteServiceInterruptionMutation();
  const loading = false;

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onDelete = () => {
    if (orgSlug && id) {
      deleteServiceInterruption({ orgSlug, id })
        .then(() => {
          setServiceInterruptionId();
          onClose(null, 'anyway');
        })
        .catch(() => {})
        .finally();
    }
  };

  return (
    <Dialog open={visible} onClose={onClose} fullScreen={false}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Loading text={'Loading Building...'} height={240} />
        ) : (
          <Box sx={{ paddingBottom: 2 }}>
            <Typography variant="body2" color="textSecondary">
              Do you really want to cancel this service interruption?
            </Typography>
            <Typography variant="body2" color="textSecondary">
              This process cannot be undone.
            </Typography>
          </Box>
        )}
      </DialogContent>

      {!loading && (
        <DialogActions>
          <SubmitButton loading={loading_submit} label={submitButtonLabel} onClick={onDelete} />
        </DialogActions>
      )}

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
